import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LicensePanelComponent } from './license-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CardItemComponent } from './components/card-item/card-item.component';

@NgModule({
  declarations: [LicensePanelComponent, CardItemComponent],
  exports: [LicensePanelComponent, CardItemComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class LicensePanelModule { }
